/** Default school for single-tenant coca-web deploys (see VITE_DEFAULT_SCHOOL_ID). */
export function getDefaultSchoolId(): string {
  const id = import.meta.env.VITE_DEFAULT_SCHOOL_ID?.trim();
  if (id) {
    return id;
  }

  const message =
    'VITE_DEFAULT_SCHOOL_ID 未配置：请在 .env 或构建环境中设置默认学校 ID';

  if (import.meta.env.PROD) {
    throw new Error(message);
  }

  console.error(`[Config] ${message}`);
  return '';
}
